import { render, staticRenderFns } from "./DocumentInput.vue?vue&type=template&id=4c8eee24"
import script from "./DocumentInput.vue?vue&type=script&lang=js"
export * from "./DocumentInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports